function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';
import { ButtonArchive, ButtonCancel, ButtonClose, ButtonSave } from '@arc/frontend/ui-buttons';
import { styles as modalStyles } from './Modal';
import { ModalWithLayout } from './ModalWithLayout';
const styles = {
  header: /*#__PURE__*/css(modalStyles.modalHeader, "display:flex;justify-content:space-between;padding-top:0.75rem;padding-bottom:0.75rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:header;")),
  footer: /*#__PURE__*/css(modalStyles.modalFooter, "padding-top:1.5rem;padding-bottom:0.75rem;" + (process.env.NODE_ENV === "production" ? "" : ";label:footer;"))
};
function getContent(args, t) {
  switch (args.type) {
    case 'save':
      {
        return {
          header: args.headerContent,
          body: args.bodyContent,
          cancel: args.cancelButtonContent,
          confirm: args.confirmButtonContent
        };
      }
    case 'archive':
      {
        return {
          header: args.headerContent ?? t('modal.confirmArchive'),
          body: args.bodyContent,
          cancel: args.cancelButtonContent,
          confirm: args.confirmButtonContent
        };
      }
    case 'discard-changes':
      {
        return {
          header: args.headerContent ?? t('modal.discardChanges'),
          body: args.bodyContent ?? t('modal.discardChangesBody'),
          cancel: args.cancelButtonContent ?? t('buttons.stay'),
          confirm: args.confirmButtonContent ?? t('buttons.discard')
        };
      }
    case 'discard-draft':
      {
        return {
          header: args.headerContent ?? t('modal.discardDraft'),
          body: args.bodyContent ?? t('modal.discardDraftBody'),
          cancel: args.cancelButtonContent ?? t('buttons.stay'),
          confirm: args.confirmButtonContent ?? t('buttons.discard')
        };
      }
    case 'delete-filter':
      {
        return {
          header: args.headerContent ?? t('modal.deleteFilter'),
          body: args.bodyContent ?? t('modal.deleteFilterBody'),
          cancel: args.cancelButtonContent ?? t('buttons.cancel'),
          confirm: args.confirmButtonContent ?? t('buttons.delete')
        };
      }
    case 'dismiss':
      {
        return {
          header: args.headerContent,
          body: args.bodyContent,
          cancel: args.cancelButtonContent ?? t('buttons.dismiss'),
          disableConfirm: true,
          disableCancel: false
        };
      }
    default:
      {
        return {
          header: args.headerContent,
          body: args.bodyContent,
          cancel: args.cancelButtonContent,
          confirm: args.confirmButtonContent
        };
      }
  }
}
var _ref = process.env.NODE_ENV === "production" ? {
  name: "e6n021",
  styles: "margin-left:1rem;cursor:pointer"
} : {
  name: "1kdnzqp-ModalDialog",
  styles: "margin-left:1rem;cursor:pointer;label:ModalDialog;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export function ModalDialog({
  show,
  onCancel,
  onConfirm,
  type = 'save',
  ...props
}) {
  const {
    t
  } = useTranslation('common');
  const isSaveButton = type === 'save';
  const ConfirmButton = isSaveButton ? ButtonSave : ButtonArchive;
  const {
    header,
    body,
    cancel,
    confirm,
    disableConfirm,
    disableCancel
  } = getContent({
    ...props,
    type
  }, t);
  return <ModalWithLayout dialogStyleOverrides={props.dialogStyleOverrides} show={show} onRequestClose={onCancel} testid={props.testId ?? 'modal-dialog'} topOffset={props.topOffset} header={<div css={styles.header}>
					{type === 'info' ? <>
							{header}
							<div css={_ref}>
								<ButtonClose onClick={onCancel} />
							</div>
						</> : header}
				</div>} body={body} footerStyle={[styles.footer, type === 'info' && {
    display: 'none'
  }]} footer={<>
					{disableCancel ? null : <ButtonCancel onClick={onCancel}>{cancel}</ButtonCancel>}

					{disableConfirm ? null : <ConfirmButton onClick={onConfirm} variant="contained" data-disabled={props['data-disabled']} data-cy={type === 'archive' ? 'archive-confirm' : 'dialog-confirm'} disabled={props['data-disabled']}>
							{confirm}
						</ConfirmButton>}
				</>} />;
}